var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("dossiers")) + " "),
          _c("w-spacer"),
          _c("span", { staticClass: "dossier-count" }, [
            _vm._v(
              " " +
                _vm._s(_vm.dossiers.length) +
                "/" +
                _vm._s(_vm.maxDossiers) +
                " "
            ),
          ]),
        ],
        1
      ),
      _c(
        "w-list",
        [
          _vm._l(_vm.dossiers, function (dossier) {
            return _c(
              "w-list-item",
              { key: dossier.id },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(dossier.name))]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.edit"),
                            expression: "$ct('common.edit')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editDossier(dossier)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              attrs: { disabled: !_vm.canCreateDossier },
              on: {
                click: function ($event) {
                  return _vm.addDossier()
                },
              },
            },
            [
              _c("w-list-item-text", [
                _c(
                  "div",
                  [
                    _c("w-fa", { attrs: { icon: "plus" } }),
                    _vm._v(" " + _vm._s(_vm.$ct("common.add")) + " "),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }